import { render, staticRenderFns } from "./RouteTransition.vue?vue&type=template&id=269a3518&lang=pug&"
var script = {}
import style0 from "./RouteTransition.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports